/** @format */

export const DEFAULT_TEST_ID = 'price-modifier-options';
